import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { useState } from "react";
const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
     



      {/* Main Navbar */}
     <nav className="bg-[#fff9e6] shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-20">

          {/* LOGO */}
          <Link to="/" className="flex items-center">
            <img
              src={logo}
              alt="Meenakshi Cook"
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* DESKTOP MENU */}
          <ul className="hidden md:flex space-x-10 text-gray-700 font-medium items-center">
            <li className="hover:text-orange-600">
              <Link to="/">My Recipes</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to="/contact">Contact</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to="/about">About Me</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to="/shop">Shop</Link>
            </li>
          </ul>

          {/* MOBILE HAMBURGER */}
          <button
            className="md:hidden text-3xl"
            onClick={() => setOpen(!open)}
            aria-label="Toggle Menu"
          >
            ☰
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="md:hidden bg-[#fff9e6] border-t">
          <ul className="flex flex-col items-center gap-6 py-6 text-gray-700 font-medium">
            <li onClick={() => setOpen(false)}>
              <Link to="/">My Recipes</Link>
            </li>
            <li onClick={() => setOpen(false)}>
              <Link to="/contact">Contact</Link>
            </li>
            <li onClick={() => setOpen(false)}>
              <Link to="/about">About Me</Link>
            </li>
            <li onClick={() => setOpen(false)}>
              <Link to="/shop">Shop</Link>
            </li>
          </ul>
        </div>
      )}
    </nav>

    </>
  );
};

export default Header;
